import React from 'react';
import './Marker.css';
import DefaultImage from './Default.png';
import MarkerImage from './Marker.png'

const Marker = (props: any) => {
    
	const { color, name, id } = props;
    
	const getCirclePath = (photoUrl) => {
		if (photoUrl != undefined) {
			if (photoUrl.endsWith('photo.jpg')) {
				var splitted = photoUrl.split('/');
				splitted[splitted.length-2] = 's76-cc-rp';
				return splitted.join('/');
			} else {	
				return photoUrl.split('=')[0].concat('=s76-cc-rp');
			}
		}
	}

	if (props.userState.photoUrl !== undefined) {
		return (
		  <div title={name} className="marker" onClick={() => { props.onClick(props.userState) }}>
			<img src={MarkerImage} className="icon"/>
			<img src={getCirclePath(props.userState.photoUrl)} className="profilePhoto"/>
		  </div>
		);
	} else { 
		return (
		  <div title={name} className="marker" onClick={() => { props.onClick(props.userState) }}>
			<img src={MarkerImage} className="icon"/>
			<img src={DefaultImage} className="profilePhoto"/>
		  </div>
		)
	}
};

export default Marker;